
import {IDS} from "./pnp-settings.constants";

export const dashboardState = {
    name: IDS.app_policies_settings_dashboard,
    url: '',
    component: 'dashboard',
};

export const documentTypeState = {
    name: IDS.app_policies_settings_document_types,
    abstract: true,
    url: '/document-types'
};

export const documentTypeDashboardState = {
    name: IDS.app_policies_settings_document_types_dashboard,
    url: '',
    component: 'dashboard',
};

export const adddocumentTypeState = {
    name: IDS.app_policies_settings_document_types_add,
    url: `/add`,
    component: 'pnpDocumentTypesDetails',
};

export const manageDocumentdocumentTypeState = {
    name: IDS.app_policies_settings_document_types_manage,
    url: `/manage`,
    component: 'pnpDocumentTypesGrid',
};

export const categoryState = {
    name: IDS.app_policies_settings_categories,
    abstract: true,
    url: '/categories'
};

export const categoryDashboardState = {
    name: IDS.app_policies_settings_categories_dashboard,
    url: '',
    component: 'dashboard',
};

export const approvalworkflowState = {
    name: IDS.app_policies_settings_approval_workflows,
    abstract: true,
    url: '/approval-workflows'
};

export const approvalworkflowDashboardState = {
    name: IDS.app_policies_settings_approval_workflows_dashboard,
    url: '',
    component: 'dashboard',
};